import { AbbottLogo } from '@abbott-components/core';
import { Box, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

export default () => {
  return (
    <AppBar position="absolute" elevation={1}>
      <Toolbar>
        <Typography
          sx={{
            flexGrow: 1,
            padding: '0.4rem',
            height: '4rem'
          }}
          component={Box}
        >
          <div
            style={{
              minWidth: '100px',
              maxWidth: '200px',
              padding: '0.8rem',
              height: '3rem'
            }}
          >
            <AbbottLogo color="white" />
          </div>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
